






























import { Component, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { IRole, UserStatus } from 'admiral-core';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class UserStatusSelect extends mixins(BaseMixin) {
  @Prop({ type: Boolean, default: () => false })
  multiple!: boolean;

  @Prop()
  status!: UserStatus | UserStatus[];

  @Prop({ required: false, default: () => [UserStatus.ACTIVE, UserStatus.DEACTIVATED] })
  options!: IRole[];

  @Prop({ type: Boolean, required: false, default: () => false })
  disabled!: boolean;

  updateUserStatus(status: UserStatus | UserStatus[]) {
    this.$emit('update-user-status', status);
  }

  isSelected(s: UserStatus) {
    if (Array.isArray(this.status)) {
      return this.status.find((status: UserStatus) => status === s);
    } else {
      return this.status === s;
    }
  }
  statusLabel(status: UserStatus) {
    return Util.formatUserStatus(status);
  }

  statusDescription(status: UserStatus) {
    return Util.formatUserStatusDescription(status);
  }
}
